import { render, staticRenderFns } from "./NewInfections.vue?vue&type=template&id=1dd867c8&"
import script from "./NewInfections.vue?vue&type=script&lang=js&"
export * from "./NewInfections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports